/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { map } from 'rxjs/operators';
import { DocumentTypeEntity } from 'src/app/distribution/models';
import { Partner, PartnerLoadOptions, PartnerSystem } from 'src/app/partner/models';
import { PartnerSystemService } from 'src/app/partner/services/partner-system.service';
import { PartnerService } from 'src/app/partner/services/partner.service';
import { DataFieldGroup } from 'src/app/shared/datafields/models';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { Stakeholder } from 'src/app/stakeholder/models/stakeholder';
import { StakeholderService } from 'src/app/stakeholder/services/stakeholder.service';
import { StatusType } from 'src/app/tracking/models';
import { StatusTypeService } from 'src/app/tracking/services/status-type.service';
import { CurrentUserService } from 'src/app/user/services';
import { ArtifactAssemblyTypes, AssemblyArtifact } from '../models/artifact';
import { StatusEventSubscription, StatusEventSubscriptionDisplay } from '../models/status-event-subscription';
import { DeveloperArtifactService } from '../services/developer-artifact.service';
import { DeveloperService } from '../services/developer.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule, DxTagBoxModule, DxDropDownBoxModule } from 'devextreme-angular';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoPopupModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoHeaderFilterModule, DxoLookupModule, DxiButtonModule, DxoPagingModule, DxoScrollingModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DeveloperArtifactAssemblyPickerComponent } from '../developer-artifacts/developer-artifact-assembly-picker.component';
import { NgStyle } from '@angular/common';
import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';
import { PartnerSelectorComponent } from '../../partner/partner-selector.component';
import { BizGridFiltervalues } from '../../shared/grid/biz-grid-filtervalues';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { GridService } from '../../shared/grid/grid.service';

@Component({
  selector: 'app-developer-status-events',
  templateUrl: './developer-status-events.component.html',
  styleUrls: ['./developer-status-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule,
            DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoHeaderFilterModule, DxoLookupModule, DxiButtonModule, DxTemplateModule, DeveloperArtifactAssemblyPickerComponent,
            DataFieldGroupContainerComponent, PartnerSelectorComponent, DxTagBoxModule, NgStyle, DxDropDownBoxModule, DxoPagingModule, DxoScrollingModule, DxoSelectionModule, FormsModule,
            BizUserColumnDirective, BizDateColumnDirective]
})
export class DeveloperStatusEventsComponent implements OnInit {
  private readonly toastService = inject(ToastService);
  private readonly loadingPanelService = inject(LoadingPanelService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly developerArtifactService = inject(DeveloperArtifactService);
  private readonly partnerService = inject(PartnerService);
  private readonly statusTypeService = inject(StatusTypeService);
  private readonly stakeholderService = inject(StakeholderService);
  private readonly developerService = inject(DeveloperService);
  private readonly partnerSystemService = inject(PartnerSystemService);
  public readonly bizGridFiltervalues = inject(BizGridFiltervalues);
  private readonly gridService = inject(GridService);

  allowAdding = false;
  allowUpdating = false;
  allowDeleting = false;
  allowShowLog = false;

  subscriptions: StatusEventSubscriptionDisplay[] = [];
  statusTypes: StatusType[] = [];
  subscriptionStatusTypes: StatusType[] = [];
  partnerSystems: PartnerSystem[] = [];
  documentTypes: DocumentTypeEntity[] = [];
  stakeholders: Stakeholder[] = [];
  artifacts: AssemblyArtifact[] = [];
  documentTypeNone: DocumentTypeEntity[] = [{ Id: 0, Name: '', Description: 'Not filtered on document type' } as DocumentTypeEntity];
  statusEventHandlerDataFields: DataFieldGroup[] = [];
  statusEventHandlerFormGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor() {
    this.allowAdding = this.currentUserService.hasPermission('Developer_Action_StatusEventSubscription_Create');
    this.allowUpdating = this.currentUserService.hasPermission('Developer_Action_StatusEventSubscription_Edit');
    this.allowDeleting = this.currentUserService.hasPermission('Developer_Action_StatusEventSubscription_Delete');
    this.allowShowLog = this.currentUserService.hasPermission('Developer_Action_ShowLog');
  }

  ngOnInit(): void {
    void this.refresh();
  }

  async refresh(): Promise<void> {
    let tmpSubscriptions: StatusEventSubscriptionDisplay[] = [];
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading subscriptions...');

      await Promise.all([
        this.statusTypeService.getStatusTypes().then(result => this.statusTypes = result.sort((a, b) => a.StatusTypeName.localeCompare(b.StatusTypeName))),
        this.developerService.getDocumentTypes().then(result => this.documentTypes = this.documentTypeNone.concat(result)),
        this.stakeholderService.getStakeholders().then(result => this.stakeholders = result.sort((a, b) => a.Name.localeCompare(b.Name))),
        this.partnerSystemService.getAllPartnerSystems().then(result => this.partnerSystems = result.sort((a, b) => a.Name.localeCompare(b.Name))),
        this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeStatusEventHandler, ArtifactAssemblyTypes.TypeStatusEventHandler2]).then(result => this.artifacts = result),
        this.developerService.getStatusEventSubscriptions().pipe(
          map(subsciptions => subsciptions.map(subsciption => new StatusEventSubscriptionDisplay(subsciption)))
        ).toPromise().then(result => tmpSubscriptions = result)
      ]);

      const partnerInIds = tmpSubscriptions.filter(s => !!s.PartnerInId).map<number>(s => s.PartnerInId);
      const partnerOutIds = tmpSubscriptions.filter(s => !!s.PartnerOutId).map<number>(s => s.PartnerOutId);
      const partnerAllIds = partnerInIds.concat(partnerOutIds)
        .filter((val, idx, self) => self.indexOf(val) === idx); // distinct;
      const partners = await this.partnerService.getPartners(partnerAllIds, new PartnerLoadOptions(false));

      tmpSubscriptions.forEach(subscription => {
        subscription.PartnerIn = Object.assign(new Partner(), partners.find(e => e.PartnersId === subscription.PartnerInId));
        subscription.PartnerOut = Object.assign(new Partner(), partners.find(e => e.PartnersId === subscription.PartnerOutId));
      });
    }
    finally {
      this.subscriptions = tmpSubscriptions;
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  onEditingStart(ev: any) {
    this.statusEventHandlerDataFields = [];

    let customNames = ev.key.StatusNames;
    customNames = customNames.filter((el) => !this.statusTypes.map(st => st.StatusTypeName).includes(el));

    const customStatusTypes = customNames.map(cst => {
      const newItem = {
        StatusTypesId: -1,
        StatusTypeName: cst,
        StatusTypeDescription: '',
        IsTechnicalStatus: true
      };
      return newItem;
    });

    this.subscriptionStatusTypes = this.statusTypes.concat(customStatusTypes);
  }

  onRowValidating(ev: any): void {
    this.statusEventHandlerFormGroup.updateValueAndValidity();
    ev.isValid = ev.isValid && this.statusEventHandlerFormGroup.valid;
  }

  async selectedArtifactIdChange(ev: any, cellInfo: any): Promise<void> {
    const artifactId: string = ev || null;
    const subscription: StatusEventSubscriptionDisplay = cellInfo.row.data;

    cellInfo.setValue(artifactId);

    this.statusEventHandlerDataFields = artifactId
      ? await this.developerService.getStatusEventSubscriptionFieldGroups(subscription.SubscriptionsId, artifactId)
      : [];
  }

  onInitNewRow(e: any): void {
    e.data = new StatusEventSubscriptionDisplay();
    this.statusEventHandlerDataFields = [];
    this.subscriptionStatusTypes = this.statusTypes;
  }

  onRowInserting = (e: DxDataGridTypes.RowInsertingEvent<StatusEventSubscriptionDisplay>): void => {
    e.cancel = this.gridService.handleDataGridRow(e.data, item => this.saveStatusEventSubscriptionDisplay(item));
  };

  onRowUpdating = (e: DxDataGridTypes.RowUpdatingEvent<StatusEventSubscriptionDisplay>): void => {
    // This deviates from standard procedure because StatusEventSubscriptionDisplay is a class and not an interface.
    const item: StatusEventSubscriptionDisplay = Object.assign(new StatusEventSubscriptionDisplay(), e.oldData, e.newData);
    e.cancel = this.gridService.handleDataGridRow<StatusEventSubscriptionDisplay>(item, item => this.saveStatusEventSubscriptionDisplay(item));
    e.newData = item;
  };

  onRowRemoving = (e: DxDataGridTypes.RowRemovingEvent<StatusEventSubscriptionDisplay>): void => {
    e.cancel = this.gridService.handleDataGridRow(e.data, item => this.deleteStatusEventSubscriptionDisplay(item));
  };

  async deleteStatusEventSubscriptionDisplay(item: StatusEventSubscriptionDisplay): Promise<StatusEventSubscriptionDisplay> {
    await this.developerService.deleteStatusEventSubscription(item.SubscriptionsId);
    this.toastService.showToast('Subscription deleted...', ToastType.success);
    return item;
  }

  async saveStatusEventSubscriptionDisplay(item: StatusEventSubscriptionDisplay): Promise<StatusEventSubscriptionDisplay> {
    item.PartnerInId = item.PartnerIn?.PartnersId ?? 0;
    item.PartnerOutId = item.PartnerOut?.PartnersId ?? 0;

    const result = await this.saveStatusEventSubscription(item);
    this.toastService.showToast('Subscription saved...', ToastType.success);
    return Object.assign(item, result);
  }

  async saveStatusEventSubscription(subscription: StatusEventSubscription): Promise<StatusEventSubscription> {
    try {
      const statusEventHandlerDataFieldValues = DataFieldGroup.getDataFieldValues(this.statusEventHandlerDataFields, true);
      const savedItem = await this.developerService.saveStatusEventSubscription(subscription, statusEventHandlerDataFieldValues);
      this.toastService.showToast('Subscription saved...', ToastType.success);
      return savedItem;
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Failed to save subscription...', ToastType.error);
      return undefined;
    }
  }

  onPartnerChanged(partner: Partner, cellInfo: any): void {
    cellInfo.setValue(partner);
  }

  //List into List HeaderFilterData with dataBind on Id
  getDocumentTypeHeaderFilterData = () => {
    const documentTypeMap = new Map(this.documentTypes.map(dt => [dt.Id, dt.Name]));

    return this.subscriptions
      .map(e => e.DocumentTypeId) // Extract DocumentTypeId from each subscription
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = documentTypeMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      }) // Map DocumentTypeId to its name
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  };

  getPartnerSystemHeaderFilterData = () => {
    const partnerSystemMap = new Map(this.partnerSystems.map(ps => [ps.Id, ps.Name]));

    return this.subscriptions
      .map(e => e.PartnerSystemId) // Extract PartnerSystemId from each subscription
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = partnerSystemMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      }) // Map PartnerSystemId to its name
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  };

  getStakeholderHeaderFilterData = () => {
    const stakeHolderMap = new Map(this.stakeholders.map(s => [s.StakeholdersId, s.Name]));

    return this.subscriptions
      .map(e => e?.StakeholderId) // Extract StakeholderId from each subscription
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = stakeHolderMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      }) // Map StakeholderId to its name
      .sort((a, b) => a?.name?.localeCompare(b?.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  };

  getStatusNamesHeaderFilterData = () =>
    (this.subscriptions ?? []) // Ensure contacts is defined; default to an empty array if undefined
      .flatMap(e => {
        const statusName = e.StatusNames?.map(statusName => statusName) || [];
        return statusName.length > 0 ? statusName : ['(Blanks)'];
      }) // Flatten the RoleName values from all Roles, or add '(blanks)' if no permissions
      .filter((name, idx, self) => self.indexOf(name) === idx) // Remove duplicates
      .sort((a, b) => a.localeCompare(b)) // Sort the names alphabetically
      .map(statusName => ({
        text: statusName,
        value: statusName
      }));

  //Object Inside Object HeaderFilter
  getPartnerOutHeaderFilterData = () => this.subscriptions
    .map(e => e.PartnerOut?.PartnerName ?? '(Blanks)')
    .filter((val, idx, self) => self.indexOf(val) === idx)
    .sort()
    .map(val => ({
      text: val,
      value: val
    }))
    ;

  getPartnerInHeaderFilterData = () => this.subscriptions
    .map(e => e.PartnerIn?.PartnerName ?? '(Blanks)')
    .filter((val, idx, self) => self.indexOf(val) === idx)
    .sort()
    .map(val => ({
      text: val,
      value: val
    }))
    ;

  //GENERIC Object Into Object FilterExpression
  calculateFilterExpression(filterValue: any, selectedFilterOperation: string) {
    const column = this as any;
    const operation = selectedFilterOperation ?? 'contains';

    if (filterValue === '(Blanks)') {
      return [row => !row[column.dataField]?.PartnerName];
    }

    return [column.displayField, operation, filterValue];
  }

  calculateArrayFilterExpression(filterValue: any) {
    // Custom filter for array fields
    return (rowData: any) => {
      if (filterValue === '(Blanks)') {
        // Check if there are no permissions
        return !rowData.StatusNames || rowData.StatusNames.length === 0;
      }
      return rowData.StatusNames?.some((statusName: any) =>
        statusName?.toLowerCase().includes(filterValue.toLowerCase())
      );
    };
  }

  onValueChangedForStatustype(ev: any, cellInfo: any) {
    let ids: number[] = ev.value;
    ids = ids.sort((a, b) => this.statusTypes.findIndex(st => st.StatusTypesId === a) - this.statusTypes.findIndex(st => st.StatusTypesId === b));
    cellInfo.setValue(ids);
  }

  onValueChangedForStakeholder(ev: any, cellInfo: any) {
    const stakeholderId: number = ev;
    cellInfo.setValue(stakeholderId);
  }

  onValueChangedForPartnerSystem(ev: any, cellInfo: any) {
    const partnerSystemId: number = ev;
    cellInfo.setValue(partnerSystemId);
  }

  // For use with grid in drop down template
  onSelectionChangedForDocumentType(selectedRowKeys, cellInfo, dropDownBoxComponent): void {
    cellInfo.setValue(selectedRowKeys[0]);
    if (selectedRowKeys.length > 0) {
      dropDownBoxComponent.close();
    }
  }

  onCustomItemCreating(args: any) {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const { component, text } = args;
    const currentItems = component.option('items');

    const newItem = {
      StatusTypesId: -1,
      StatusTypeName: text.trim(),
      StatusTypeDescription: '',
      IsTechnicalStatus: true
    };

    const itemInDataSource = currentItems.find((item) => item.StatusTypeName.toUpperCase() === newItem.StatusTypeName.toUpperCase());
    if (itemInDataSource) {
      args.customItem = itemInDataSource;
    } else {
      currentItems.push(newItem);
      component.option('items', currentItems);
      args.customItem = newItem;
    }
  }
}
